"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecodeURIComponentValue = exports.getCookieForMessage = exports.Cookie = void 0;
var getDecodeURIComponentValue = function (value) {
    try {
        return decodeURIComponent(value);
    }
    catch (_a) {
        return value;
    }
};
exports.getDecodeURIComponentValue = getDecodeURIComponentValue;
var Cookie = {
    get: function (n) {
        var m = document.cookie.match(new RegExp("(^| )" + n + "=([^;]*)(;|$)"));
        return !m ? '' : getDecodeURIComponentValue(m[2]);
    },
    getXsrf: function () {
        return Cookie.get('TOK') || '';
    },
};
exports.Cookie = Cookie;
/**
 *  获取上行消息里携带 Cookie
 *
 * @returns {string}
 */
var getCookieForMessage = function () {
    var cookiePairs = document.cookie.split(';');
    var messageCookie = cookiePairs.map(function (pair) {
        var _a = __read(/(\w+)=(.*)/.exec(pair.trim()) || [], 3), full = _a[0], key = _a[1], value = _a[2];
        if (!key)
            return full;
        return key + "=" + getDecodeURIComponentValue(value);
    }).join(';');
    return messageCookie;
};
exports.getCookieForMessage = getCookieForMessage;
